<ada-container
	*ngIf="payload.blacklistOrWhitelist; else WhitelistMessage"
	horizontalSpacing="Medium"
	verticalSpacing="Medium"
	[colCount]="4"
	[padding]="ui.Spacing.SPACING_LARGE"
>
	<ada-label
		content="Blacklist"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	>
		<ada-text
			content="True if you want to blacklist the patch/release, false if you want to whitelist it"
			data-container-selector="label-info-text"
		/>
	</ada-label>
	<ada-toggle-switch
		data-testid="blacklist-on-toggle-switch"
		[isDisabled]="true"
		[isToggled]="payload.blacklistOrWhitelist"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
	/>
	<ada-label
		content="Hidden"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	>
		<ada-text
			content="True if you are hiding the blacklisted metadata from the customer UI"
			data-container-selector="label-info-text"
		/>
	</ada-label>
	<ada-toggle-switch
		data-testid="blacklist-hidden-toggle-switch"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[(isToggled)]="payload.hidden"
	/>
	<ada-label
		content="Reason"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	>
		<ada-text
			content="Optional reason for blacklisting the patch/release, or null when whitelisting"
			data-container-selector="label-info-text"
		/>
	</ada-label>
	<ada-input
		data-testid="blacklist-reason-input"
		minHeight="8rem"
		placeholder="Blacklist reason"
		type="textarea"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="payload.reason"
	/>
	<ada-label
		content="Vendor URL"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_LABEL_CONFIG"
	>
		<ada-text
			content="Optional vendor URL with information on why the patch was blacklisted, or null when whitelisting"
			data-container-selector="label-info-text"
		/>
	</ada-label>
	<ada-input
		data-testid="blacklist-vendor-url-input"
		placeholder="Vendor URL"
		[responsiveConfiguration]="ui.ResponsiveConfig.DEFAULT_FIELD_CONFIG"
		[showAsFullWidth]="true"
		[(value)]="payload.vendorUrl"
	/>
</ada-container>
<ng-template #WhitelistMessage>
	<ada-container
		horizontalSpacing="Medium"
		verticalSpacing="Medium"
		[padding]="ui.Spacing.SPACING_LARGE"
	>
		<ada-text content="Please confirm whitelisting for {{ context.objectName }}" />
	</ada-container>
</ng-template>
